import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BookYourSaintHubertService() {
  return <section data-section-id="252496" id="צרו-קשר" className="bg-background py-16 md:py-24">
      <div className="page-container">
        <div className="bg-primary text-primary-foreground rounded-lg p-8 md:p-16 flex flex-col items-center text-center gap-8 shadow-xl">
          <div className="space-y-4 max-w-3xl">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
              זקוקים למטפל סיעודי באופן מיידי?
            </h2>
            <p className="text-lg md:text-xl opacity-90 font-default">
              אנחנו כאן כדי לספק לכם מענה מקצועי, אנושי ומהיר תוך 5 שעות בלבד. הצוות שלנו ערוך להעניק ליקירכם את הטיפול המסור והאיכותי ביותר בכל רגע נתון.
            </p>
          </div>
          
          <Button size="lg" className="bg-secondary text-secondary-foreground hover:opacity-90 text-base md:text-lg h-14 px-8 rounded-md shadow-lg transition-all" asChild>
            <Link to="/ContactPage">
              <SafeHydrate><Calendar className="ml-2 size-5" /></SafeHydrate>
              תיאום ייעוץ והתאמת מטפל
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}